module.exports = __webpack_public_path__ + "img/vippack-active.3cb9e11c.svg";